import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  autoCompleteUnderline: {
    "&:before": {
      border: ["none", "!important"],
    },
    "&:after": {
      border: ["none", "!important"],
    },
  },
  autocomplete: {
    paddingLeft: "5px",
    height: "29px",
    borderRadius: "5px",
  },
  label: {
    marginBottom: "2px",
    marginLeft: "3px",
  },
}))

export default styles
